import React, { Component } from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import * as config from "@Configs/globalConfig";

export const PrivateRoute = ({ component: ComposedComponent, ...rest }) => {
  class Authentication extends Component {
    // redirect if not authenticated; otherwise, return the component imputted into <PrivateRoute />
    handleRender(props) {
      if (!this.props.authReducer.authenticated) {
        return (
          <>
            {(window.location.href = config.ACCOUNT_PORTAL_URL + "/login?m=rs")}
          </>
        );
      } else {
        return <ComposedComponent {...props} />;
      }
    }

    render() {
      return <Route {...rest} render={this.handleRender.bind(this)} />;
    }
  }

  function mapStateToProps(state) {
    return {
      authReducer: state.authReducer,
    };
  }

  const AuthenticationContainer = connect(mapStateToProps)(Authentication);
  return <AuthenticationContainer />;
};
